import { render } from "./completed-trips-card.vue?vue&type=template&id=3679bdb1&scoped=true"
import script from "./completed-trips-card.vue?vue&type=script&lang=js"
export * from "./completed-trips-card.vue?vue&type=script&lang=js"

import "./completed-trips-card.vue?vue&type=style&index=0&id=3679bdb1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3679bdb1"]])

export default __exports__